import { circleAiConversationsApi } from "@circle-react/api/circleAiConversationsApi";
import { useInfiniteQuery } from "react-query";

const PAGE_SIZE = 20;

export const CIRCLE_AI_CONVERSATIONS_QUERY_KEY = "circle-ai-conversations";

export const useRecentChatsList = ({
  query,
  enabled = true,
  perPage = PAGE_SIZE,
}: {
  enabled?: boolean;
  perPage?: number;
  query: string;
}) =>
  useInfiniteQuery({
    queryKey: [CIRCLE_AI_CONVERSATIONS_QUERY_KEY, query, perPage],
    queryFn: ({ pageParam = 1 }) =>
      circleAiConversationsApi.list({
        params: { page: pageParam, per_page: perPage, query },
      }),
    enabled,
    initialPageParam: 1,
    getNextPageParam: ({ pagination }) => {
      const hasMore =
        pagination.page * pagination.per_page < pagination.total_count;
      if (!hasMore) return undefined;
      return pagination.page + 1;
    },
  });
